export class GrowerDealerOrderTransferVM {
  rowId: number;
  CropYear: number;
  CompanyCode: string;
  ItemId: number;
  ItemNumber: string;
  ItemDescription: string;
  Brand: string;
  MarketingBrand: string;
  PrimaryUom: string;
  Conv: number;
  FromShipToAccount: number;
  OriginalFromQty: number;
  FromDeliveryDate: string;
  FromCustomerPO: string;
  FromGLN: string;
  FromSellerId: number;
  ToShipToAccount: number;
  ToQty: number;
  ToDeliveryDate: string;
  ToDeliveryDateForCalendar: string;
  ToCustomerPO: string;
  ToGLN: string;
  ToSellerId: number;
  FromChangeType: string;
  ToChangeType: string;
  FromGMK: number;
  ToGMK: number;
  LineErrors: any;
  EmailTo: string;

  FromPrimaryQtyGO: number;
  FromModifyQtyGO: number;
  FromQtyGO: number;
  FromOrderIdGO: number;
  FromOrderNoGO: string;
  FromOrderItemIdGO: number;
  FromOrderItemIdsGO: number[] = [];
  ToOrderNoGO: string;
  ToOrderIdGO: number;
  ToPrimaryQtyGO: number;
  ToSecondaryQtyGO: number;

  FromPrimaryQtyDO: number;
  FromModifyQtyDO: number;
  FromOrderIdDO: number;
  FromOrderNoDO: string;
  FromOrderItemIdDO: number;
  ToOrderIdDO: number;
  ToPrimaryQtyDO: number;
  ToSecondaryQtyDO: number;

  TransferableUnitsDO: number;
  RemainingQuantityDO: number;
  DealerModifiableUnits: number;
  SoftCommitUnits: number;
  seedNonReturnable: boolean;
  isRib: boolean;
  isValidForRibTransfer: boolean;
}
